import { render, staticRenderFns } from "./BOM.vue?vue&type=template&id=66843e44&scoped=true&lang=pug"
import script from "./BOM.vue?vue&type=script&lang=js"
export * from "./BOM.vue?vue&type=script&lang=js"
import style0 from "./BOM.vue?vue&type=style&index=0&id=66843e44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66843e44",
  null
  
)

export default component.exports